export const OperationAgreementRouting = [
  {
    path: "/maintenance/operation-agreement",
    name: "maintenance-operation-agreement-list",
    meta: { title: "运维协议" },
    component: () =>
      import(
        /* webpackChunkName: "maintenance-operation-agreement" */ "@/views/maintenance/operation-agreement/list/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/maintenance/operation-agreement/create",
    name: "maintenance-operation-agreement-create",
    meta: { title: "新建运维协议", comName: "MaintenanceOperationAgreementFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "maintenance-operation-agreement" */ "@/views/maintenance/operation-agreement/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/maintenance/operation-agreement/edit/:id",
    name: "maintenance-operation-agreement-edit",
    meta: { title: "编辑运维协议", comName: "MaintenanceOperationAgreementFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "maintenance-operation-agreement" */ "@/views/maintenance/operation-agreement/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/maintenance/operation-agreement/detail/:id",
    name: "maintenance-operation-agreement-detail",
    meta: { title: "运维协议详情" },
    component: () =>
      import(
        /* webpackChunkName: "maintenance-operation-agreement" */ "@/views/maintenance/operation-agreement/form-detail/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/maintenance/operation-agreement/flowPrint/:id",
    name: "maintenance-operation-agreement-flow-print",
    meta: { title: "运维协议打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "maintenance-operation-agreement" */ "@/views/maintenance/operation-agreement/flow-print/index.vue"
      ),
  },
];
